import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Diary } from '../models/diary.model';
import { DocumentText } from '../models/documentText.model';

import { ClientConfigService } from './client-config.service';

@Injectable({
  providedIn: 'root'
})
export class OpenOnboardingService {
  private httpClient = inject(HttpClient);
  private clientConfigService = inject(ClientConfigService);



  private get apiAddress(): string {
    return environment.apiManagement.address;
  }

  private getHeaders(isJson = true): HttpHeaders {
    let headers = new HttpHeaders().set('Ocp-Apim-Subscription-Key', environment.apiManagement.subscriptionKey);
    if (isJson) {
      headers = headers.set('Content-Type', 'application/json');
    }
    return headers;
  }

  getDiaryByPolicyCode(policyCode: string): Observable<Diary[]> {
    const customHeaders = this.getHeaders();

    return this.httpClient.get<Diary[]>(
      `${this.apiAddress}api/OpenOnboarding/GetDiaryByPolicyCode?PolicyCode=${policyCode}&brokerId=${this.clientConfigService.getBrokerId()}`,
      { headers: customHeaders }
    );
  }

  uploadDocuments(fd: FormData): Observable<any> {
    const customHeaders = this.getHeaders(false);

    if (!fd.has('brokerId')) {
      fd.append('brokerId', this.clientConfigService.getBrokerId());
    }

    return this.httpClient.post(
      // `${this.apiAddress}api/documents/upload?subscription-key=${environment.apiManagement.subscriptionKey}`,
      `${this.apiAddress}api/OpenOnboarding/upload`,
      fd,
      {
        headers: customHeaders,
        reportProgress: true,
        observe: 'events',
      }
    );
  }

  uploadTextFile(model: DocumentText) {
    const customHeaders = this.getHeaders();
    
    model.brokerId = this.clientConfigService.getBrokerId();

    return this.httpClient.post(`${this.apiAddress}api/OpenOnboarding/uploadTextFile`, model, {
      reportProgress: true,
      observe: 'events',
      headers: customHeaders,
    });
  }

  getFileToDownload(filename: string) {
    const customHeaders = this.getHeaders();

    return this.httpClient.get(
      `${this.apiAddress}api/OpenOnboarding/getFileToDownload?fileName=${filename}&brokerId=${this.clientConfigService.getBrokerId()}`,
      {
        headers: customHeaders,
        responseType: 'blob',
      }
    );
  }

}
